import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import { NitroHeading, NitroIcon, NitroPlaceholder } from 'nitro-components';

import tinycolor from 'tinycolor2';

const Container = styled.section`
  position: relative;
  margin: 40px 0 60px;
`;

const EditButtonWrapper = styled.button`
  border: 0;
  outline: 0;

  position: absolute;
  top: 0;
  right: -16px;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background: ${props => tinycolor(props.theme.color.secondary).setAlpha(0.1).toString()};
  &:hover {
    background: ${props => tinycolor(props.theme.color.secondary).setAlpha(0.2).toString()};
  }
`;

const Content = styled.div`
  text-align: center;
  align-items: center;
`;

class SummarySection extends Component {
  stepHandler = () => {
    this.props.action(this.props.step);
  };

  render() {
    const { title, children } = this.props;

    // const ChildrenComponent = children;
    return (
      <Container>
        <NitroHeading align="center" label={title} variant="base1" size="2" />
        <EditButtonWrapper onClick={this.stepHandler}>
          <NitroIcon name="edit" size={14} variant="secondary" />
        </EditButtonWrapper>
        <NitroPlaceholder size={20} />
        <Content>
          {children}
        </Content>
      </Container>
    );
  }
}

SummarySection.propTypes = {
  title: PropTypes.string,
  step: PropTypes.number,
  action: PropTypes.func
};

export default SummarySection;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Summary/SummarySection.js